module.exports = __webpack_public_path__ + "6f9c84bb71aa0cf3769edaac01cb1128.pdf";